import React, { useState, useEffect } from "react";
import ColorPopup from "./ColorPopup";

const MenuPageModal = ({
  isOpen,
  onClose,
  onSave,
  pageId,
  formDataInput,
  currentPage,
  pageWidth,
  pageHeight,
}) => {
  const [formData, setFormData] = useState({
    pageId: pageId,
    name: "",
    pageTheme: "",
    browserBackground: "#dddddd",
    pageBackground: "#ffffff",
    marginTop: 10,
    marginBottom: 10,
    pageWidth: "480",
    pageHeight: "768",
    fillMode: "solid",
    gradientColor1: "#ffffff",
    gradientColor2: "#000000",
    gradientAngle: 0,
  });

  
  useEffect(() => {
    if (formDataInput) {
      setFormData({
        pageId: pageId,
        name: formDataInput.name || "",
        pageTheme: formDataInput.pageTheme || "",
        browserBackground: formDataInput.browserBackground || "#dddddd",
        pageBackground: formDataInput.pageBackground || "#ffffff",
        marginTop: formDataInput.marginTop ?? 10,
        marginBottom: formDataInput.marginBottom ?? 10,
        pageWidth: pageWidth?.toString() || "480",
        pageHeight: pageHeight?.toString() || "768",
        fillMode: formDataInput.fillMode || "solid",
        gradientColor1: formDataInput.gradientColor1 || "#ffffff",
        gradientColor2: formDataInput.gradientColor2 || "#000000",
        gradientAngle: formDataInput.gradientAngle ?? 0,
      });
    }


  }, [formDataInput, pageId, pageWidth, pageHeight]);


  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    onSave({
      ...formData,
      pageId,
    });
    onClose();
  };

  const handleClose = () => {
    setFormData((prev) => ({
      ...prev,
      pageWidth: pageWidth?.toString(),
      pageHeight: pageHeight?.toString(),
    }));
    onClose();
  };

  if (!isOpen) return null;

  const styles = {
    backdrop: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 50,
    },
    modal: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "16px",
      width: "90%",
      maxWidth: "460px",
      boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    },
    pageIdDisplay: {
      fontSize: "11px",
      marginBottom: "8px",
      color: "#555",
    },
    label: {
      display: "block",
      marginBottom: "10px",
      fontSize: "13px",
    },
    input: {
      display: "block",
      width: "100%",
      padding: "5px 8px",
      marginTop: "4px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "13px",
      boxSizing: "border-box",
    },
    colorInput: {
      display: "inline-block",
      width: "50px",
      height: "30px",
      marginTop: "4px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      cursor: "pointer",
    },
    row: {
      display: "flex",
      gap: "10px",
      marginBottom: "10px",
    },
    col: {
      flex: 1,
    },
    modalButtons: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "8px",
      marginTop: "16px",
    },
    button: {
      padding: "5px 10px",
      fontSize: "13px",
      borderRadius: "4px",
      border: "none",
      cursor: "pointer",
    },
    cancel: {
      backgroundColor: "#e0e0e0",
    },
    save: {
      backgroundColor: "#007bff",
      color: "#fff",
    },
    sectionTitle: {
      fontSize: "13px",
      fontWeight: "600",
      marginBottom: "6px",
      marginTop: "10px",
    },
  };

  const renderBrowserBackground = () => {
    if (currentPage === 1) {
      return (
        <label style={styles.label}>
          Browser Background (All Pages)
          <ColorPopup
              color={formData.browserBackground}
              onChange={(color) =>
                handleChange("browserBackground", color)
              }
            />
        </label>
      );
    }
    return null;
  };
  
  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h2 style={{ marginTop: 0, marginBottom: "10px" }}>Menu Page Settings</h2>

        {pageId && (
          <div style={styles.pageIdDisplay}>Page ID: {pageId.slice(-7)}</div>
        )}

        <label style={styles.label}>
          Page Name {currentPage === 1?"(website title can be entered here)":""}
          <input
            style={styles.input}
            type="text"
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />
        </label>

        <div style={styles.row}>
          <div style={styles.col}>
            <label style={styles.label}>
              Page Width
              <input
                type="number"
                value={formData.pageWidth}
                onChange={(e) => handleChange("pageWidth", e.target.value)}
                style={styles.input}
              />
            </label>
          </div>

          <div style={styles.col}>
            <label style={styles.label}>
              Page Height
              <input
                type="number"
                value={formData.pageHeight}
                onChange={(e) => handleChange("pageHeight", e.target.value)}
                style={styles.input}
              />
            </label>
          </div>
        </div>

        <div style={styles.row}>
          <div style={styles.col}>
            <label style={styles.label}>
              Top Margin
              <input
                style={styles.input}
                type="number"
                value={formData.marginTop}
                onChange={(e) => handleChange("marginTop", e.target.value)}
              />
            </label>
          </div>

          <div style={styles.col}>
            <label style={styles.label}>
              Bottom Margin
              <input
                style={styles.input}
                type="number"
                value={formData.marginBottom}
                onChange={(e) => handleChange("marginBottom", e.target.value)}
              />
            </label>
          </div>
        </div>

        {renderBrowserBackground()}

        <div style={styles.sectionTitle}>Page Fill</div>

        <div style={styles.row}>
          <label>
            <input
              type="radio"
              checked={formData.fillMode === "solid"}
              onChange={() => handleChange("fillMode", "solid")}
            />
            Solid
          </label>

          <label>
            <input
              type="radio"
              checked={formData.fillMode === "gradient"}
              onChange={() => handleChange("fillMode", "gradient")}
            />
            Gradient
          </label>
        </div>

        {formData.fillMode === "solid" ? (
          <label style={styles.label}>
            Page Background Color
            <ColorPopup
              color={formData.pageBackground}
              onChange={(color) =>
                handleChange("pageBackground", color)
              }
            />


          </label>
        ) : (
          <>
            <div style={styles.row}>
              <div style={styles.col}>
                <label style={styles.label}>
                  Gradient Color 1
                  <ColorPopup
                    color={formData.gradientColor1}
                    onChange={(color) =>
                      handleChange("gradientColor1", color)
                    }
                  />

                </label>
              </div>

              <div style={styles.col}>
                <label style={styles.label}>
                  Gradient Color 2
                  <ColorPopup
                    color={formData.gradientColor2}
                    onChange={(color) =>
                      handleChange("gradientColor2", color)
                    }
                  />

                </label>
              </div>
            </div>

            <label style={styles.label}>
              Gradient Angle
              <input
                type="number"
                min="0"
                max="360"
                value={formData.gradientAngle}
                onChange={(e) => handleChange("gradientAngle", e.target.value)}
                style={styles.input}
              />
            </label>
          </>
        )}

        <div style={styles.modalButtons}>
          <button
            style={{ ...styles.button, ...styles.cancel }}
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            style={{ ...styles.button, ...styles.save }}
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenuPageModal;

